import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4061cb27"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h4 title fw-normal text-primary mb-16" }
const _hoisted_2 = { class: "fw-bold" }
const _hoisted_3 = { class: "middle-container" }
const _hoisted_4 = { class: "middle-content mb-16" }
const _hoisted_5 = { class: "form" }
const _hoisted_6 = { class: "row row-cols-2 gx-12" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "content" }
const _hoisted_11 = { class: "row gx-12" }
const _hoisted_12 = { class: "col-6" }
const _hoisted_13 = { class: "content" }
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = { class: "content" }
const _hoisted_16 = { class: "row gx-12" }
const _hoisted_17 = { class: "col-12" }
const _hoisted_18 = { class: "content" }
const _hoisted_19 = { class: "row gx-12" }
const _hoisted_20 = { class: "col-12" }
const _hoisted_21 = { class: "content" }
const _hoisted_22 = { class: "observations mb-24" }
const _hoisted_23 = { class: "content" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col" }
const _hoisted_26 = { class: "section-title fw-bold d-flex justify-content-between align-items-center mb-12" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-add me-8" }, null, -1))
const _hoisted_28 = { class: "authorizations" }
const _hoisted_29 = { class: "d-inline product" }
const _hoisted_30 = { class: "d-inline product" }
const _hoisted_31 = { class: "d-inline product" }
const _hoisted_32 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-view-light fw-bold icon-xs" }, null, -1))
const _hoisted_34 = {
  key: 1,
  class: "item d-flex align-items-center justify-content-between"
}
const _hoisted_35 = { class: "add" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-add text-xs fw-bold" }, null, -1))
const _hoisted_37 = { class: "bottom-section d-flex align-items-center justify-content-end" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-home me-12",
  "aria-hidden": "true"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_form_group_input_datetime = _resolveComponent("v-form-group-input-datetime")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_form_group_select = _resolveComponent("v-form-group-select")!
  const _component_v_loader = _resolveComponent("v-loader")!
  const _component_v_form_group_textarea = _resolveComponent("v-form-group-textarea")!
  const _component_v_button = _resolveComponent("v-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_the_purchase_authorization_create = _resolveComponent("the-purchase-authorization-create")!
  const _component_the_purchase_authorization_show = _resolveComponent("the-purchase-authorization-show")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("h2", _hoisted_1, [
        _createTextVNode(_toDisplayString(_ctx.$t('Editar')) + " ", 1),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('consulta')), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_v_form_group_input_datetime, {
                    value: _ctx.initDate,
                    label: _ctx.$t('Fecha de inicio*'),
                    class: "mb-24",
                    "yup-errors-variable": _ctx.errors.initDate,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_ctx.initDate = $event))
                  }, null, 8, ["value", "label", "yup-errors-variable"])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_v_form_group_input_datetime, {
                    value: _ctx.endDate,
                    label: _ctx.$t('Fecha de fin'),
                    class: "mb-24",
                    "yup-errors-variable": _ctx.errors.endDate,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.endDate = $event))
                  }, null, 8, ["value", "label", "yup-errors-variable"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_v_form_group_select, {
                    label: _ctx.$t('Tipo de consulta'),
                    class: "mb-24",
                    "yup-errors-variable": _ctx.errors.type
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        class: _normalizeClass({'is-invalid': !!_ctx.errors.type}),
                        options: _ctx.formsSettings.consultation_type_options,
                        reduce: returnValue => returnValue.key,
                        "select-on-key-codes": [188, 13],
                        clearable: false,
                        modelValue: _ctx.type,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.type) = $event))
                      }, {
                        "no-options": _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                        ]),
                        _: 1
                      }, 8, ["class", "options", "reduce", "modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label", "yup-errors-variable"])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_v_form_group_select, {
                    label: _ctx.$t('Medio consulta*'),
                    class: "mb-24",
                    "yup-errors-variable": _ctx.errors.via
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        class: _normalizeClass({'is-invalid': !!_ctx.errors.via}),
                        options: _ctx.formsSettings.consultation_via_options,
                        reduce: returnValue => returnValue.key,
                        "select-on-key-codes": [188, 13],
                        clearable: false,
                        modelValue: _ctx.via,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.via) = $event))
                      }, {
                        "no-options": _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                        ]),
                        _: 1
                      }, 8, ["class", "options", "reduce", "modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label", "yup-errors-variable"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  (_ctx.isLoading)
                    ? (_openBlock(), _createBlock(_component_v_loader, { key: 0 }))
                    : (_openBlock(), _createBlock(_component_v_form_group_select, {
                        key: 1,
                        label: _ctx.$t('Consulta física*'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.clinicId
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            class: _normalizeClass({'is-invalid': !!_ctx.errors.clinicId}),
                            options: _ctx.clinicOptions,
                            reduce: returnValue => returnValue.key,
                            "select-on-key-codes": [188, 13],
                            clearable: true,
                            modelValue: _ctx.clinicId,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.clinicId) = $event))
                          }, {
                            "no-options": _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                            ]),
                            _: 1
                          }, 8, ["class", "options", "reduce", "modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label", "yup-errors-variable"]))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_v_form_group_select, {
                    label: _ctx.$t('Tratamiento'),
                    class: "mb-24",
                    "yup-errors-variable": _ctx.errors.treatmentId
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        class: _normalizeClass({'is-invalid': !!_ctx.errors.treatmentId}),
                        options: _ctx.treatmentOptions,
                        placeholder: "- Sin tratamiento asociado -",
                        reduce: returnValue => returnValue.key,
                        "select-on-key-codes": [188, 13],
                        modelValue: _ctx.treatmentId,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.treatmentId) = $event))
                      }, {
                        "no-options": _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                        ]),
                        _: 1
                      }, 8, ["class", "options", "reduce", "modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label", "yup-errors-variable"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_v_form_group_textarea, {
                  label: _ctx.$t('Observaciones'),
                  idKey: "observations",
                  value: _ctx.observations,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.observations = $event))
                }, null, 8, ["label", "value"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createTextVNode(_toDisplayString(_ctx.$t('Autorizaciones relacionadas')) + " ", 1),
                (_ctx.can('professional.expedient.purchase-authorization.store'))
                  ? (_openBlock(), _createBlock(_component_v_button, {
                      key: 0,
                      variant: "secondary",
                      size: "xs",
                      class: "new-consultation",
                      "aria-label": _ctx.$t('Nueva autorización'),
                      onClick: _ctx.showPurchaseAuthorizationCreateModal
                    }, {
                      default: _withCtx(() => [
                        _hoisted_27,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('Nueva')), 1)
                      ]),
                      _: 1
                    }, 8, ["aria-label", "onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_28, [
                (_ctx.consultationAuthorizations().length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.consultationAuthorizations(), (purchaseAuthorization, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "item d-flex align-items-center justify-content-between",
                        key: index
                      }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$str.formatDate(purchaseAuthorization.dueDate)), 1),
                          _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('Estado')) + ": " + _toDisplayString(_ctx.status(purchaseAuthorization.status)), 1),
                          _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('{count} productos distintos', { count: purchaseAuthorization.products.length})), 1)
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _createVNode(_component_v_button, {
                            variant: "icon",
                            class: "p-0 me-16",
                            onClick: ($event: any) => {_ctx.setCurrentPurchase(purchaseAuthorization);
                      _ctx.modalToShow = 'the-purchase-authorization-show'}
                          }, {
                            default: _withCtx(() => [
                              _hoisted_33
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ]))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_ctx.$t('No hay autorizaciones relacionadas con esta consulta')), 1)),
                _createElementVNode("div", _hoisted_35, [
                  (_ctx.can('professional.expedient.purchase-authorization.store'))
                    ? (_openBlock(), _createBlock(_component_v_button, {
                        key: 0,
                        variant: "icon",
                        class: "w-100 justify-content-center",
                        "aria-label": _ctx.$t('Nueva autorización'),
                        onClick: _ctx.showPurchaseAuthorizationCreateModal
                      }, {
                        default: _withCtx(() => [
                          _hoisted_36
                        ]),
                        _: 1
                      }, 8, ["aria-label", "onClick"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_37, [
        (_ctx.can('professional.expedient.consultation.index'))
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: {name: 'professional.expedient.show', params: {
        tabName: 'consultas',
        consultation: _ctx.currentConsultation.id
        },
        query: {
          tratamiento: _ctx.currentTreatment?.id,
          }},
              class: "btn btn-link-secondary btn-icon btn-sm edit-consultation me-24",
              "aria-label": _ctx.$t('Cancelar')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Cancelar')), 1)
              ]),
              _: 1
            }, 8, ["to", "aria-label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_button, {
          variant: "secondary",
          class: "new-consultation",
          "aria-label": _ctx.$t('Guardar'),
          onClick: _ctx.updateConsultation,
          disabled: !_ctx.meta.valid || _ctx.accepted,
          "is-loading": _ctx.accepted
        }, {
          default: _withCtx(() => [
            _hoisted_38,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('Guardar')), 1)
          ]),
          _: 1
        }, 8, ["aria-label", "onClick", "disabled", "is-loading"])
      ])
    ]),
    (_ctx.modalToShow === 'the-purchase-authorization-create')
      ? (_openBlock(), _createBlock(_component_the_purchase_authorization_create, {
          key: 0,
          "consultation-id": _ctx.currentConsultation.id,
          onClosed: _cache[7] || (_cache[7] = ($event: any) => (_ctx.modalToShow = null)),
          onPurchaseAuthorizationCreated: _cache[8] || (_cache[8] = ($event: any) => {_ctx.loadPurchaseAuthorizations(); _ctx.modalToShow = null})
        }, null, 8, ["consultation-id"]))
      : _createCommentVNode("", true),
    (_ctx.modalToShow === 'the-purchase-authorization-show')
      ? (_openBlock(), _createBlock(_component_the_purchase_authorization_show, {
          key: 1,
          onClosed: _cache[9] || (_cache[9] = ($event: any) => {_ctx.modalToShow = null; _ctx.setCurrentPurchase()})
        }))
      : _createCommentVNode("", true)
  ], 64))
}